<template>
    <div>
        <Checkbox :value="Checked" size="large" @on-change="selectFilter">
            {{Item.Title}} 
            <span v-if="ShowCount()">({{Item.Count}})</span>
        </Checkbox>
        
    </div>
</template>


<script>

export default {
	name: 'FilterBucketItem',
	props: {
        Item: Object,
        SelectedFilterOptions: String
    },
    computed: {
        Checked: {
            get() {
                if (this.SelectedFilterOptions.split('+').includes(this.Item.Term))
                    return true;
                else
                    return false;
            }
        }
    },
    methods: {
        selectFilter() {
          this.$emit('changeBucket', this.Item);
        },
        ShowCount() {
            return this.Item.Type == 'bucket';
        }
    }	
    
}
</script>